import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt, faSearch, faTruck } from "@fortawesome/free-solid-svg-icons";

export default function AgriLinkXpressHome() {
  const [pinCode, setPinCode] = useState("");
  const [neighbourhood, setNeighbourhood] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [basketPrepared, setBasketPrepared] = useState(false);
  const [basketItems, setBasketItems] = useState([]);
  const [cart, setCart] = useState([]);
  const [showOrderForm, setShowOrderForm] = useState(false);
  const [orderDetails, setOrderDetails] = useState({ name: "", address: "", pin: "", mobile: "", email: "" });
  const [orderPlaced, setOrderPlaced] = useState(false);

  const categories = [
    { name: "Vegetables", img: "🥦" },
    { name: "Fruits", img: "🍎" },
    { name: "Spices", img: "🌶️" },
    { name: "Batters", img: "🥞" },
    { name: "Dairy", img: "🥛" },
    { name: "Poultry", img: "🐓" },
    { name: "Fish", img: "🐟" },
  ];

  const dummyItems = {
    Vegetables: [
      { name: "Tomato", unit: "kg", marketPrice: 40, offerPrice: 35, img: "https://via.placeholder.com/80?text=Tomato" },
      { name: "Potato", unit: "kg", marketPrice: 30, offerPrice: 25, img: "https://via.placeholder.com/80?text=Potato" },
      { name: "Spinach", unit: "bunch", marketPrice: 20, offerPrice: 18, img: "https://via.placeholder.com/80?text=Spinach" },
    ],
    Fruits: [
      { name: "Apple", unit: "kg", marketPrice: 120, offerPrice: 100, img: "https://via.placeholder.com/80?text=Apple" },
      { name: "Banana", unit: "dozen", marketPrice: 50, offerPrice: 40, img: "https://via.placeholder.com/80?text=Banana" },
      { name: "Mango", unit: "kg", marketPrice: 150, offerPrice: 130, img: "https://via.placeholder.com/80?text=Mango" },
    ],
    Spices: [
      { name: "Turmeric Powder", unit: "100g pack", marketPrice: 200, offerPrice: 180, img: "https://via.placeholder.com/80?text=Turmeric" },
      { name: "Chili Powder", unit: "100g pack", marketPrice: 150, offerPrice: 120, img: "https://via.placeholder.com/80?text=Chili" },
    ],
    Batters: [
      { name: "Besan", unit: "kg", marketPrice: 90, offerPrice: 80, img: "https://via.placeholder.com/80?text=Besan" },
      { name: "Rice Batter", unit: "kg", marketPrice: 70, offerPrice: 60, img: "https://via.placeholder.com/80?text=Rice+Batter" },
    ],
    Dairy: [
      { name: "Milk", unit: "liter", marketPrice: 50, offerPrice: 45, img: "https://via.placeholder.com/80?text=Milk" },
      { name: "Curd", unit: "500g pack", marketPrice: 40, offerPrice: 35, img: "https://via.placeholder.com/80?text=Curd" },
    ],
    Poultry: [
      { name: "Chicken", unit: "kg", marketPrice: 200, offerPrice: 180, img: "https://via.placeholder.com/80?text=Chicken" },
      { name: "Eggs", unit: "dozen", marketPrice: 60, offerPrice: 50, img: "https://via.placeholder.com/80?text=Eggs" },
    ],
    Fish: [
      { name: "Rohu", unit: "kg", marketPrice: 250, offerPrice: 220, img: "https://via.placeholder.com/80?text=Rohu" },
      { name: "Pomfret", unit: "kg", marketPrice: 400, offerPrice: 350, img: "https://via.placeholder.com/80?text=Pomfret" },
    ],
  };

  const offersOfTheDay = [
    { name: "Tomato", offerQty: 2, msg: "Buy 2 kg Tomatoes at ₹30 per kg!" },
    { name: "Apple", offerQty: 3, msg: "Buy 3 kg Apples at ₹90 per kg!" },
    { name: "Chicken", offerQty: 1, msg: "Get Chicken at ₹180 per kg today!" },
    { name: "Milk", offerQty: 2, msg: "Buy 2 liters Milk at ₹40 each!" },
  ];

  const handlePrepareBasket = () => {
    if (!selectedCategory) return alert("Select a category first!");
    if (!pinCode.trim() || !neighbourhood.trim()) return alert("Enter PIN Code and Neighbourhood!");
    setBasketItems(dummyItems[selectedCategory] || []);
    setBasketPrepared(true);
    setCart([]);
  };

  const handleAddToCart = (item) => {
    const existing = cart.find((c) => c.name === item.name);
    if (existing) {
      setCart(cart.map(c => c.name === item.name ? { ...c, qty: c.qty + 1 } : c));
    } else {
      setCart([...cart, { ...item, qty: 1 }]);
    }
  };

  const handleQtyChange = (itemName, delta) => {
    setCart(cart.map(c => {
      if (c.name === itemName) {
        const newQty = c.qty + delta;
        if (newQty <= 0) return null;
        return { ...c, qty: newQty };
      }
      return c;
    }).filter(Boolean));
  };

  const handleRemoveItem = (itemName) => setCart(cart.filter(c => c.name !== itemName));

  const handlePlaceOrder = () => {
    let offerMatched = false;
    offersOfTheDay.forEach(offer => {
      const cartItem = cart.find(c => c.name === offer.name);
      if (cartItem && cartItem.qty >= offer.offerQty) offerMatched = true;
    });
    if (offerMatched) {
      if (!window.confirm("Your cart qualifies for today's offer. Place order with offer?")) return;
    }
    if (cart.length === 0) return alert("Add at least one item to cart!");
    setShowOrderForm(true);
  };

  const handleSubmitOrder = () => {
    const { name, address, pin, mobile, email } = orderDetails;
    if (!name || !address || !pin || !mobile || !email) return alert("Fill all order details!");
    setOrderPlaced(true);
    setShowOrderForm(false);
  };

  return (
    <div className="min-h-screen bg-black flex flex-col">
      {/* Header */}
      <header className="bg-green-800 p-4 text-white flex flex-col md:flex-row md:items-center md:justify-between shadow-md">
        <h1 className="text-m lg:text-xl font-bold mb-2 md:mb-0">AgriXpress : Vegetable, Fruits, Spices, Batters, Dairy, Poultry & Fish Delivery in few minutes</h1>
      </header>

      {/* Search Bar */}
      <div className="flex flex-row justify-center p-4 bg-black text-white shadow-sm">
        <div className="flex justify-start space-x-2">
          <FontAwesomeIcon className="mt-4" icon={faMapMarkerAlt} />
          <input
            type="text"
            value={pinCode}
            onChange={(e) => setPinCode(e.target.value)}
            placeholder="Enter PIN Code"
            className="px-2 py-1 rounded text-black w-48 md:w-60"
          />
        </div>
        <div className="flex justify-start w-full bg-black border border-green-500 p-2 rounded-lg">
          <FontAwesomeIcon icon={faSearch} className="text-white" />
          <input
            type="text"
            value={neighbourhood}
            onChange={(e) => setNeighbourhood(e.target.value)}
            placeholder="Search neighbourhood or product"
            className="ml-2 bg-transparent outline-none flex-1"
          />
        </div>
      </div>

      {/* Categories Grid */}
      <div className="p-4 grid grid-cols-4 sm:grid-cols-7 gap-2 place-items-center">
        {categories.map((cat) => (
          <div
            key={cat.name}
            onClick={() => setSelectedCategory(cat.name)}
            className={`flex flex-col items-center bg-white rounded-xl shadow p-4 cursor-pointer hover:scale-105 transition transform ${
              selectedCategory === cat.name ? "border-2 border-green-700" : ""
            }`}
          >
            <div className="text-4xl mb-2">{cat.img}</div>
            <span className="text-sm font-medium text-center">{cat.name}</span>
          </div>
        ))}
      </div>

      {/* Prepare Basket Button */}
      <div className="p-4 flex justify-center items-center">
        <button
          onClick={handlePrepareBasket}
          className="w-48 bg-green-700 text-white py-2 rounded-lg hover:bg-green-800 flex items-center justify-center space-x-2"
        >
          Prepare Your Basket
        </button>
      </div>

      {/* Basket Items */}
      {basketPrepared && (
        <>
          <div className="p-4 bg-black border border-green-400 rounded shadow mb-4">
            <h3 className="text-yellow-300 text-xl font-bold">🔥 Offers of the Day 🔥</h3>
            <ul className="list-disc text-white pl-5">
              {offersOfTheDay.map((offer) => (
                <li key={offer.name}>{offer.msg}</li>
              ))}
            </ul>
          </div>

          <div className="p-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            {basketItems.map((item) => (
              <div key={item.name} className="bg-black text-white border border-green-500 p-4 rounded shadow flex flex-col items-center">
                <img src={item.img} alt={item.name} className="w-20 h-20 object-cover mb-2 rounded" />
                <span className="font-medium text-white">{item.name} ({item.unit})</span>
                <span className="line-through text-sm text-white">₹{item.marketPrice} / {item.unit}</span>
                <span className="text-white font-bold">₹{item.offerPrice} / {item.unit}</span>
                <button
                  onClick={() => handleAddToCart(item)}
                  className="mt-2 w-20 bg-green-600 text-white py-1 px-3 rounded hover:bg-green-700"
                >
                  Add
                </button>
              </div>
            ))}
          </div>
        </>
      )}

      {/* Cart & Place Order */}
      {basketPrepared && (
        <div className="p-4">
          <h3 className="text-yellow-200 text-m  lg:text-xl font-bold mb-2">Cart</h3>
          {cart.length === 0 ? (
            <p>No items added yet.</p>
          ) : (
            <div className="space-y-2">
              {cart.map((c) => (
                <div key={c.name} className="flex justify-between bg-black text-white border border-green-500 p-2 rounded shadow items-center">
                  <div className="flex items-center gap-2">
                    <img src={c.img} alt={c.name} className="w-10 h-10 object-cover rounded" />
                    <span>{c.name} ({c.unit})</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <button
                      onClick={() => handleQtyChange(c.name, -1)}
                      className="bg-blue-700 text-white px-2 rounded hover:bg-blue-800"
                    >
                      -
                    </button>
                    <span>{c.qty}</span>
                    <button
                      onClick={() => handleQtyChange(c.name, +1)}
                      className="bg-blue-700 text-white px-2 rounded hover:bg-blue-800"
                    >
                      +
                    </button>
                    <span>₹{c.offerPrice * c.qty}</span>
                    <button
                      onClick={() => handleRemoveItem(c.name)}
                      className="bg-red-600 text-white px-2 rounded hover:bg-red-700"
                    >
                      Remove
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
          <button
            onClick={handlePlaceOrder}
            className="mt-4 w-48 bg-green-700 text-white py-2 rounded-lg flex items-center justify-center space-x-2 hover:bg-green-800"
          >
            <FontAwesomeIcon icon={faTruck} />
            <span>Place Xpress Order</span>
          </button>
        </div>
      )}

      {/* Order Form */}
      {showOrderForm && (
        <div className="p-4 bg-black text-white border border-green-500 shadow rounded m-4">
          <h3 className="text-yellow-200 text-m lg:text-xl font-bold mb-2">Enter Delivery Details</h3>
          <div className="flex flex-col gap-2 justify-start">
            {["name", "address", "pin", "mobile", "email"].map((field) => (
              <input
                key={field}
                type="text"
                placeholder={field.charAt(0).toUpperCase() + field.slice(1)}
                value={orderDetails[field]}
                onChange={e => setOrderDetails({ ...orderDetails, [field]: e.target.value })}
                className="p-2 border rounded"
              />
            ))}
          </div>
          <button
            onClick={handleSubmitOrder}
            className="mt-4 w-36 bg-green-700 text-white py-2 rounded hover:bg-green-800"
          >
            Confirm Order
          </button>
        </div>
      )}

      {/* Dummy Invoice */}
      {orderPlaced && (
        <div className="p-4 bg-black text-white border border-green-500 shadow rounded m-4">
          <h3 className="text-yellow-200 text-xl font-bold mb-2">Order Placed Successfully!</h3>
          <h3 className="text-white font-bold mb-2">You shall get the delivery in 5-10 minutes!</h3>
          <h3 className="text-white text-xl font-bold mb-2">This is COD Order. Pay on delivery by Cash or digitally.</h3>
          <p>Invoice / Delivery Challan:</p>
          <ul className="list-disc pl-5">
            {cart.map((c) => (
              <li key={c.name}>
                {c.name} ({c.unit}) x {c.qty} = ₹{c.offerPrice * c.qty}
              </li>
            ))}
          </ul>
          <p>Total: ₹{cart.reduce((a, b) => a + b.offerPrice * b.qty, 0)}</p>
        </div>
      )}

      {/* Footer */}
      <footer className="mt-auto bg-green-800 text-white text-center p-4 text-sm">
        © 2025 ThinkXpress by Think5Whys
      </footer>
    </div>
  );
}
